export default [
    {
      title: 'menu.Logout',
      icon: 'LogOutIcon',
      tagVariant: 'light-danger',
      route:'logout'
    },
  ]
  